import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  inject,
  OnChanges,
} from '@angular/core';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { TableComponent } from '@app/shared/components/table/table.component';
import { Pagination } from '../../../../../../shared/model/pagination.model';
import { ApiService } from '@core/providers/http';
import { BolsaService, BolseiroService } from '../../../api/services';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { TableColumn } from '@shared/components/table/table.component';
import { Menu } from 'primeng/menu';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Subject, takeUntil } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { InstituicaoEnsinoService } from '../../../api/services/instituicao-ensino.service';
import { toExtensoComMoeda } from '@app/core/helpers/toExtensoComMoeda';
import { Textarea } from 'primeng/textarea';

interface VerificarRegraPagamentoPayload {
  id: string;
  pedidoID: number;
  bolseiroID: number;
  requerenteID: number;
  isActive: boolean;
  tipoBolsa: number;
  paisID: number;
  instituicaoGestoraID: number;
  nivelAcademico: number;
  areaProgramaFormacaoID: number;
  programaFormacaoID: number;
  anoCurricularFrequencia: string;
  valorSubsidio: number;
}

@Component({
  selector: 'app-cancelamento-bolsa',
  imports: [
    SearchBarComponent,
    TableComponent,
    CommonModule,
    ReactiveFormsModule,
    Select,
    InputTextModule,
    NgxMaskPipe,
    NgxMaskDirective,
    DataVoidComponent,
    Textarea
  ],
  providers: [
    ApiService,
    BolseiroService,
    BolsaService,
    provideNgxMask(),
    ConfirmationService,
    MessageService,
    InstituicaoEnsinoService,
  ],
  standalone: true,
  templateUrl: './cancelamento-bolsa.component.html',
  styleUrl: './cancelamento-bolsa.component.scss',
})
export class CancelamentoBolsaComponent implements OnInit, OnChanges {
  @Output() formValueChanges = new EventEmitter<{
    data: any;
    valid: boolean;
  }>();
  @Input() bolseiroID!: string;
  @Input() documento!: any;
  @Input() disabled = false;
  pagination: Pagination<any> = new Pagination<any>();
  bolsaService = inject(BolsaService);
  bolseiroService = inject(BolseiroService);
  estudantes: any[] = [];
  form!: FormGroup;
  fb = inject(FormBuilder);
  instituicaoEnsinoService = inject(InstituicaoEnsinoService);
  confirm = inject(ConfirmationService);
  messageService = inject(MessageService);
  InstEnsino: any[] = [];
  private previousInstituicaoId: string | null = null;
  private destroy$ = new Subject<void>();
  columns: TableColumn[] = [
    {
      field: 'id',
      header: 'Selecione',
      type: 'radio',
      tooltip: 'Selecionar',
    },
    {
      field: 'tipoBolsaDescricao',
      header: 'Tipo',
      type: 'text',
      tooltip: 'Tipo de Bolsa',
    },
    {
      field: 'nivelAcademicoDescricao',
      header: 'Nivel Académico de Formação',
      type: 'text',
      tooltip: 'Grau Académico',
    },
    {
      field: 'estadoBolsaDescricao',
      header: 'Estado',
      type: 'tag',
      severityField: 'estadoBolsa',
      tagSeverityFunction: (rowData: any) =>
        this.getSeverity(rowData.estadoBolsaDescricao),
      tooltip: 'Estado da Bolsa',
    },
  ];

  @ViewChild('menu') menu!: Menu;
  bolsa: any;
  valorRegra: string | null = null; // formatado pt-BR (ex.: "1.250,00")

  cancelamentoMotivoOptions = [
    {
      label: 'a) Falta aos deveres consignados no presente Regulamento',
      alinea: 'a',
      alineadescricao: 'Falta aos deveres consignados',
    },
    {
      label: 'b) Falta de Aproveitamento Académico',
      alinea: 'b',
      alineadescricao: 'Falta de Aproveitamento Académico',
    },
    {
      label: 'c) Mudança de Curso sem prévia autorização do MIREMPET',
      alinea: 'c',
      alineadescricao: 'Mudança de Curso sem autorização do MIREMPET',
    },
    {
      label: 'd) Reprovação ou abandono de Curso',
      alinea: 'd',
      alineadescricao: 'Reprovação ou abandono de Curso',
    },
    {
      label: 'e) Mau comportamento académico, moral, cívico e patriótico',
      alinea: 'e',
      alineadescricao:
        'Mau comportamento académico, moral, cívico e patriótico',
    },
    {
      label: 'f) Prestação de falsas declarações',
      alinea: 'f',
      alineadescricao: 'Falsas declarações',
    },
    {
      label:
        'g) Usufruto de mais de um financiamento, total ou parcial e qualquer que seja a sua natureza ou entidade financiadora, para a formação',
      alinea: 'g',
      alineadescricao: 'Usufruto de mais de um financiamento',
    },
    {
      label:
        'h) Não apresentação de documento comprovativo do aproveitamento académico no prazo máximo de 30 dias a contar do término do ano lectivo em causa',
      alinea: 'h',
      alineadescricao: 'Não apresentação de comprovativo no prazo de 30 dias',
    },
    {
      label: 'i) Envolvimento em fraude académica',
      alinea: 'i',
      alineadescricao: 'Fraude académica',
    },
    {
      label: 'j) Prática de actos de natureza criminal',
      alinea: 'j',
      alineadescricao: 'Actos criminais',
    },
    {
      label:
        'k) Exercer qualquer actividade remunerada ou não relacionada com o programa estabelecido para a formação que possa prejudicar ou comprometer o seu sucesso académico, durante o período de duração da formação',
      alinea: 'k',
      alineadescricao: 'Actividade que comprometa o sucesso académico',
    },
    {
      label:
        'l) Em resultado de inspecção promovida pela DNFQCV do MIREMPET, após análise das informações prestadas pelo Beneficiário, pelo orientador ou responsável pela actividade do Beneficiário',
      alinea: 'l',
      alineadescricao: 'Inspecção da DNFQCV do MIREMPET',
    },
    {
      label:
        'm) A pedido, por escrito, do Beneficiário, por motivos de força maior',
      alinea: 'm',
      alineadescricao: 'Pedido por motivos de força maior',
    },
    {
      label:
        'n) Quando os objectivos da formação forem atingidos antes do prazo inicialmente previsto, situação a partir do qual, o pagamento dos subsídios deixa de ser devido, a partir do termo da formação',
      alinea: 'n',
      alineadescricao: 'Objectivos atingidos antes do prazo',
    },
    {
      label:
        'o) Outro motivo atendível, desde que previsto neste Regulamento ou na Declaração de Compromisso de Honra do Beneficiário',
      alinea: 'o',
      alineadescricao: 'Outro motivo previsto no regulamento',
    },
  ];

  constructor() {
    this.form = this.fb.group({
      instituicao: ['', Validators.required],
      estudanteID: ['', Validators.required],
      bolsaID: ['', [Validators.required]],
      alinea: ['', [Validators.required]],
      motivo: ['', [Validators.required]],
      observacao: [''],
      idioma: ['pt', [Validators.required]],
      alineadescricao: ['', [Validators.required]],
      valores: [{ value: '', disabled: true }, [Validators.required]],
      valoresextenso: [{ value: '', disabled: true }, [Validators.required]],
      moeda: [''],
    });

    this.form.get('valores')?.disable({ emitEvent: false });
    this.form.get('valoresextenso')?.disable({ emitEvent: false });

    this.form.controls['bolsaID'].valueChanges.subscribe((value) => {
      const formattedValue = {
        bolsaID: value,
        alinea: this.form.controls['alinea'].value,
        alineadescricao: this.form.controls['alineadescricao'].value,
      };
      this.formValueChanges.emit({
        data: formattedValue,
        valid: this.form.valid,
      });
    });

    this.form.controls['motivo']?.valueChanges.subscribe((value) => {
      this.form.controls['alineadescricao'].setValue(value?.alineadescricao);
      this.form.controls['alinea'].setValue(value?.alinea);
      const formattedValue = {
        bolsaID: this.form.controls['bolsaID'].value,
        alinea: this.form.controls['alinea'].value,
        alineadescricao: this.form.controls['alineadescricao'].value,
      };
      this.formValueChanges.emit({
        data: formattedValue,
        valid: this.form.valid,
      });
    });

    this.form.controls['estudanteID'].valueChanges.subscribe((value) => {
      this.pagination = new Pagination<any>().deserialize([]);
      if (!value) return;
      this.loadAllBolsa({
        BolseiroID: value,
      });
    });

    // Valor → gera extenso (parse PT → número)
    this.form
      .get('valores')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((valor) => {
        const num = this.parsePtNumber(valor);
        if (num !== null) {
          this.form
            .get('valoresextenso')
            ?.setValue(
              toExtensoComMoeda(num, this.form.get('moeda')?.value || ''),
              { emitEvent: true }
            );
        } else {
          this.form.get('valoresextenso')?.setValue('', { emitEvent: true });
        }
      });

    this.form.valueChanges.subscribe(() => this.emitFormValidity());
    this.form.statusChanges.subscribe(() => this.emitFormValidity());
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadAllBolsa({
      BolseiroID: this.form.controls['estudanteID'].value,
    });
  }

  private syncDisabled() {
    if (this.disabled) {
      this.form.disable({ emitEvent: false });
    } else {
      this.form.enable({ emitEvent: false });
      this.form.get('valores')?.disable({ emitEvent: false });
      this.form.get('valoresextenso')?.disable({ emitEvent: false });
    }
  }

  private emitFormValidity() {
    const formatted = {
      bolsaID: this.form.controls['bolsaID'].value,
      alinea: this.form.controls['alinea'].value,
      alineadescricao: this.form.controls['alineadescricao'].value,
      idioma: this.form.controls['idioma'].value,
      observacao: this.form.controls['observacao'].value,
    };
    this.formValueChanges.emit({ data: formatted, valid: this.form.valid });
  }

  onRadioChange(event: any) {
    this.form.controls['bolsaID'].setValue(event.id);
  }

  getSeverity(status: string) {
    switch (status) {
      case 'Activo':
        return 'success';
      case 'Inactivo':
        return 'warn';
      case 'Suspenso':
        return 'danger';
      case 'Finalizado':
        return 'success';
      case 'Pendente':
        return 'info';
      default:
        return 'warn';
    }
  }

  private pickMatricula(b: any) {
    const arr = Array.isArray(b?.matricula) ? b.matricula : [];
    if (!arr.length) return null;

    const emCurso = arr.find(
      (m: any) => (m?.estadoDescricao || '').toLowerCase() === 'em curso'
    );
    if (emCurso) return emCurso;

    const parse = (d: any) => (d ? new Date(d).getTime() : 0);
    return (
      arr
        .slice()
        .sort(
          (a: any, c: any) => parse(c?.dataInicio) - parse(a?.dataInicio)
        )[0] || null
    );
  }

  private buildRegraPayload(bolsa: any): VerificarRegraPagamentoPayload {
    const matricula = this.pickMatricula(bolsa);
    const anoCurricular = matricula?.anoCurricular ?? bolsa?.anoCurricular ?? 1;

    const programaFormacaoID =
      bolsa?.programaFormacaoID ??
      bolsa?.areaProgramaFormacao?.programaFormacaoId ??
      bolsa?.areaProgramaFormacao?.programaFormacaoID ??
      0;

    const bolseiroID = Number(bolsa?.bolseiroID ?? bolsa?.bolseiro?.id ?? 0);

    return {
      id: '0',
      pedidoID: Number(bolsa?.pedidoID ?? 0),
      bolseiroID,
      requerenteID: Number(bolsa?.requerenteID ?? 0),
      isActive: Boolean(bolsa?.isActive ?? true),
      tipoBolsa: Number(bolsa?.tipoBolsa ?? 0),
      paisID: Number(bolsa?.paisID ?? 0),
      instituicaoGestoraID: Number(
        bolsa?.instituicaoGestoraID ?? bolsa?.instituicaoGestora?.id ?? 0
      ),
      nivelAcademico: Number(bolsa?.nivelAcademico ?? 0),
      areaProgramaFormacaoID: Number(
        bolsa?.areaProgramaFormacaoID ?? bolsa?.areaProgramaFormacao?.id ?? 0
      ),
      programaFormacaoID: Number(programaFormacaoID),
      anoCurricularFrequencia: String(anoCurricular),
      valorSubsidio: Number(bolsa?.valorSubsidio ?? 0),
    };
  }

  private fetchValorByRegra(bolsa: any): void {
    if (!bolsa) {
      this.valorRegra = null;
      this.emitPayload();
      return;
    }

    const body = this.buildRegraPayload(bolsa);
    this.bolsaService
      .verificarRegraPagamento(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          let valor = Number(res?.valorPagamento ?? 0);
          let moeda = this.form.get('moeda')?.value ?? '';

          if (!valor || Number.isNaN(valor)) {
            const lista = Array.isArray(res?.regraPagamentoSubsidio)
              ? res.regraPagamentoSubsidio
              : [];
            const apoioFormacao =
              lista.find((x: any) => x?.subsidioId === 2) ??
              lista.find((x: any) =>
                String(x?.subsidios?.descricao ?? '')
                  .toLowerCase()
                  .includes('apoio a formação')
              );
            valor = Number(apoioFormacao?.valor ?? 0);
            moeda = apoioFormacao?.moeda ?? '';
          }

          // guarda formatações
          this.valorRegra = valor > 0 ? this.formatPtBR(valor) : null;

          // preenche inputs “valores”, “moeda”, “valoresextenso”
          const ext =
            valor > 0
              ? toExtensoComMoeda(valor, this.form.get('moeda')?.value || '')
              : '';
          this.form.patchValue(
            {
              valores: this.valorRegra ?? '',
              valoresextenso: ext,
              moeda,
            },
            { emitEvent: true }
          );
        },
        error: () => {
          this.valorRegra = null;
          this.form.patchValue(
            { valores: '0,00', valoresextenso: 'zero', moeda: '-' },
            { emitEvent: true }
          );
        },
      });
  }

  getAllBolseiros(p0: { InstituicaoEnsinoID: string }) {
    this.bolseiroService
      .list({ pageSize: 100, OrderBy: 'id desc', ...p0 })
      .subscribe((bolseiros) => {
        this.estudantes = bolseiros.data;
      });
  }

  ngOnInit(): void {
    this.getAllBolseiros({
      InstituicaoEnsinoID: this.form.controls['instituicao'].value,
    });
    this.syncDisabled();
    this.getAllInstituicoesEnsino();

    this.previousInstituicaoId = this.form.get('instituicao')?.value ?? null;

    this.form
      .get('instituicao')!
      .valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((novoId) => this.handleInstituicaoChange(novoId));
  }

  private handleInstituicaoChange(novoId: string) {
    const anterior = this.previousInstituicaoId;

    this.estudantes = [];
    if (novoId) this.getAllBolseiros({ InstituicaoEnsinoID: novoId });

    this.confirm.confirm({
      header: 'Confirmar alteração',
      message:
        'Tem a certeza que pretende mudar de instituição? Os estudantes seleccionados serão desmarcados.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, mudar',
      rejectLabel: 'Cancelar',
      accept: () => {
        this.clearStudents();
        this.previousInstituicaoId = novoId ?? null;
      },
      reject: () => {
        this.form.get('instituicao')!.setValue(anterior, { emitEvent: false });
      },
    });
  }

  private clearStudents() {
    this.estudantes = [];
    this.form.get('estudanteID')!.setValue(null);
    this.pagination = new Pagination<any>().deserialize([]);
    this.bolsa = null;
    this.messageService.add({
      severity: 'info',
      summary: 'Limpo',
      detail: 'Estudantes desmarcados ao mudar de instituição.',
    });
  }

  getAllInstituicoesEnsino() {
    this.instituicaoEnsinoService
      .list({ pageSize: 1000, OrderBy: 'ID desc' })
      .pipe(takeUntil(this.destroy$))
      .subscribe((institutions) => {
        this.InstEnsino = institutions.data;
      });
  }

  ngOnChanges(): void {
    this.syncDisabled();
  }

  loadAllBolsa(queryParams: any = {}) {
    const params = {
      ...queryParams,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
    };
    this.bolsaService
      .list({
        ...params,
        BolseiroID: queryParams.BolseiroID || this.bolseiroID,
      })
      .subscribe(
        (response) => {
          this.bolsa = response?.data?.[0];
          this.form.controls['bolsaID'].setValue(this.bolsa?.id);
          this.pagination = new Pagination<any>().deserialize(response);
          this.fetchValorByRegra(this.bolsa);
        },
        (error) => {
          console.error('Erro ao carregar bolsa:', error);
        }
      );
  }

  private parsePtNumber(value: unknown): number | null {
    if (value === null || value === undefined) return null;
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;

    // mantém dígitos, vírgula, ponto e sinal
    let s = String(value).replace(/[^\d.,-]/g, '');
    // remove separador de milhar (.) quando seguido de 3 dígitos
    s = s.replace(/\.(?=\d{3}(\D|$))/g, '');
    // vírgula decimal → ponto
    s = s.replace(',', '.');

    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }

  private resetBolsaCampos(): void {
    this.bolsa = null;
    this.valorRegra = null;
    this.form.patchValue(
      {
        bolsaID: '',
        valores: '',
        valoresextenso: '',
        moeda: '',
      },
      { emitEvent: true }
    );
    this.pagination = new Pagination<any>().deserialize([]);
  }

  private emitPayload(): void {
    const data = {
      bolsaID: this.form.get('bolsaID')?.value,
      valores: String(this.form.get('valores')?.value ?? ''),
      valoresextenso: this.form.get('valoresextenso')?.value,
      moeda: this.form.get('moeda')?.value,
      idioma: this.form.get('idioma')?.value,
      tipoDocumento: 3,
      paisBolsa: this.form.get('paisBolsa')?.value,
      estudanteID: this.form.get('estudanteID')?.value,
    };
    this.formValueChanges.emit({ data, valid: this.form.valid });
  }

  private formatPtBR(n: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n || 0);
  }
}
